import script from "./PeopleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleComponent.vue?vue&type=script&setup=true&lang=js"

import "./PeopleComponent.vue?vue&type=style&index=0&id=0edea84c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0edea84c"]])

export default __exports__